import axios from 'axios'
// 环境标识由构建时注入(VUE_APP_ENV=test|prod): 网关按 X-Env 头路由 console 的测试/生产后端
// 必须在 main.js 首行 import(axios 实例创建时才继承全局默认头), 生产发布构建需带 VUE_APP_ENV=prod
axios.defaults.headers.common['X-Env'] = process.env.VUE_APP_ENV || 'test'
